var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4228",
    "data-name": "Rectangle 4228",
    width: 26,
    height: 26,
    transform: "translate(698 304)",
    fill: "#f28e39"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01",
    "data-name": 1,
    transform: "translate(-698 -304)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receipt-01",
    transform: "translate(697.75 303.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9930",
    "data-name": "Path 9930",
    d: "M21.667,7.627V18.373a8.884,8.884,0,0,1-.542,3.651.082.082,0,0,1-.022.043,1.129,1.129,0,0,1-.921.455,3.035,3.035,0,0,1-2.015-1.181,1.915,1.915,0,0,0-3.033.163L14.04,22.956a1.982,1.982,0,0,1-1.582.878,1.982,1.982,0,0,1-1.582-.878l-1.1-1.462a1.905,1.905,0,0,0-3.012-.163l-.011.011c-1.224,1.311-2.307,1.506-2.936.726a.082.082,0,0,1-.022-.043,8.884,8.884,0,0,1-.542-3.651V7.627a8.883,8.883,0,0,1,.542-3.651c0-.011,0-.022.022-.033.618-.791,1.712-.6,2.936.715l.011.011a1.905,1.905,0,0,0,3.012-.162l1.1-1.463a1.982,1.982,0,0,1,1.582-.878,1.982,1.982,0,0,1,1.582.878L15.134,4.5a1.915,1.915,0,0,0,3.033.162,3.035,3.035,0,0,1,2.015-1.181,1.139,1.139,0,0,1,.921.466c.022.011.022.022.022.033A8.883,8.883,0,0,1,21.667,7.627Z",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9931",
    "data-name": "Path 9931",
    d: "M8.667,11.1h8.667",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9932",
    "data-name": "Path 9932",
    d: "M8.667,14.9h6.5",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanInactive);
export default __webpack_public_path__ + "static/media/loan_inactive.a77eafc25252d5c4baf0e6a11deb12ae.svg";
export { ForwardRef as ReactComponent };